/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_SubtitleInputs */



/**
* | output |
* | --- |
* | "Authorization Request" |
*
* @param {Oauth_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_subtitle = /** @type {((inputs?: Oauth_SubtitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_SubtitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demande d'autorisation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solicitud de autorización")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Solicitação de Autorização")
	if (locale === "it") return /** @type {LocalizedString} */ ("Richiesta di Autorizzazione")
	return /** @type {LocalizedString} */ ("Authorization Request")
});